// extracted by mini-css-extract-plugin
module.exports = {"textArea":"room__styles__textArea___1-7RLJ","focus":"room__styles__focus___2T319Y","disabled":"room__styles__disabled___gPOlo6","isBad":"room__styles__isBad___2Gvzvp"};